export default {
  title: {
    id: 'student_offer_title',
    defaultMessage: 'Student discount',
  },
  bigTitle: {
    id: 'student_offer_big_title',
    defaultMessage: 'Students are gonna love this page',
  },
  subtitle: {
    id: 'student_offer_subtitle',
    defaultMessage: '5% discount on all BackMarket products!',
  },
  firstCta: {
    id: 'student_offer_first_cta',
    defaultMessage: 'Get my code',
  },
  blockTitle: {
    id: 'student_offer_block_title',
    defaultMessage: 'Everything to equip yourself without breaking the bank',
  },
  blockText: {
    id: 'student_offer_block_text',
    defaultMessage:
      'Get a 5% dicount on all our products, with a minimum purchase of €5',
  },
  secondCta: {
    id: 'student_offer_second_cta',
    defaultMessage: "Let's go",
  },
  bottomTitle: {
    id: 'student_offer_bottom_title',
    defaultMessage:
      'Offer reserved for students enrolled in school or university in an eligible country.',
  },
  bottomText: {
    id: 'student_offer_bottom_text',
    defaultMessage: 'This offer is valid once a year and from €5 purchase.',
  },
  faqText: {
    id: 'student_offer_faq_text',
    defaultMessage: 'Do you have a question ? {link, html}',
  },
  faqLink: {
    id: 'student_offer_faq_link',
    defaultMessage: 'We do have answers!',
  },
  seoTitle: {
    id: 'student_offer_seo_title',
    defaultMessage: 'Discount for all students',
  },
  seoText1: {
    id: 'student_offer_seo_text1',
    defaultMessage:
      'Whether you’re heading into your first year or about to start work on your dissertation it’s important to have the necessary equipment at a price your everyday student can afford. From college to university, Back Market has got you covered with all the latest equipment (from laptops to coffee machines) to see you through those long days and longer nights.',
  },
  seoText2: {
    id: 'student_offer_seo_text2',
    defaultMessage:
      'That’s because alongside our already huge discounts on refurbished tech, all students can also take advantage of an extra 6% off everything on our website. We offer a wide range of - like new - refurbished products: laptops, tablets, 2 in 1 computers, desktops, as well as headphones, speakers, coffee machines, 4K TVs, coffee machines, consoles and more. Also check out our massive range of smartphones (so you can phone home occasionally).',
  },
}
